export default __webpack_public_path__ + "static/media/3.47c461e8.jpg";